/* eslint-disable no-param-reassign */
import isSSR from './isSSR';

/**
 * Converts the Web Catalog version of a boolean value ('1') into an actual boolean value.
 *
 * @param {any} val
 * @returns {boolean}
 */
export const parseBool = val => {
  if (typeof val === 'boolean') {
    return val;
  }
  return val === '1';
};

/*
NOTE: smooth scrollTo behaviour doesn't work in iOS 15.x, hence using
this workaround to set scrollTo behaviour to auto in iOS 15.x until bug fix is implemented by Apple
*/
/**
 * Sets scroll behaviour based on browser vendor, i.e., auto for Safari, smooth otherwise.
 * @param {object} navigator
 * @returns {string}
 */
export const getScrollBehaviour = navigator => (/(apple)/i.test(navigator.vendor) ? 'auto' : 'smooth');

/**
 * Truncates a string to the specified maximum length and appends an ellipsis ("...") if the string is longer
 * than the maximum length.
 *
 * @param {string|undefined} str - The string to truncate.
 * @param {number} maxLength - The maximum length of the string after truncation.
 * @returns {string} The truncated string if the original string exceeds the maximum length,
 * otherwise the original string.
 */
export const truncateString = (str, maxLength) => {
  if (typeof str !== 'string') {
    return '';
  }
  if (str.length > maxLength) {
    return `${str.slice(0, maxLength)}...`;
  }
  return str;
};

export const truncateLines = lineCount => ({
  overflow: 'hidden',
  display: '-webkit-box',
  overflowWrap: 'break-word',
  WebkitBoxOrient: 'vertical',
  WebkitLineClamp: lineCount,
  WebkitLineBreak: 'after-white-space',
});

export const navigateTo = url => {
  if (isSSR()) return;
  window.location.href = url;
};
